<template>
  <el-autocomplete v-model="param.materialName" :fetch-suggestions="fun_search"
                   :size="size?size:'mini'" :disabled="disabled?disabled:false"
    @change="fun_change" @select="fun_select" placeholder="请选择物料"
  ></el-autocomplete>
</template>

<script>
  import {queryBaseMaterial} from '@/api/base.js'
  export default {
    name: 'ChooseMaterial',
    props:['param','status','size','on_sel','disabled'],
    data() {
      return {
        datagrid:{rows:[]},
      }
    },
    methods: {
      fun_change(_v){
        //Object.assign(this.material,{materialName:_v})
      },
      fun_select(_v){
        Object.assign(this.param,{materialCode:_v.materialCode})
        if (this.on_sel) this.on_sel();
      },
      fun_search(q, cb){
        queryBaseMaterial({searchKey:this.sk,pageSize:999999,status:'N',orderByColumn:'material_code',orderByType:'asc'}).then(res=>{
          this.datagrid.rows.length=0;
          for(var i of res.rows){
            i.value=i.materialName;
            if(i.materialCode.length!=3) this.datagrid.rows.push(i);
          }
          var results = q ? this.datagrid.rows.filter(n=>n.value.toLowerCase().indexOf(q.toLowerCase())!=-1) : this.datagrid.rows;
          cb(results);
        })
      },
      fun_on_load(){},
    },
    mounted() {
      this.fun_on_load();
    },
  }
</script>

<style>
</style>